// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — lang-selector.styled.classic.js, новая — lang-selector.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './lang-selector.styled.classic';
import * as cp from './lang-selector.styled.cp';

export const Button = isCp ? undefined : classic.Button;
export const Caret = isCp ? cp.Caret : undefined;
export const Flag = isCp ? cp.Flag : undefined;
export const Item = isCp ? cp.Item : undefined;
export const Menu = isCp ? cp.Menu : undefined;
export const Place = isCp ? undefined : classic.Place;
export const Trigger = isCp ? cp.Trigger : undefined;
export const Wrap = isCp ? cp.Wrap : undefined;
